import create from './create';

const FormFactory = { create }
export default FormFactory;